<template>
  <div>
    <div v-if="loading" class="d-flex justify-center align-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </div>

    <v-tabs
      background-color="primary"
      dark
      slider-color="yellow"
      :value="activeTab"
      @change="updateTab"
    >
      <v-tab v-for="(item, index) in items" :key="index">{{ item.name }}</v-tab>
      <v-tabs-items v-model="activeTab" style="height:100%" touchless>
        <v-tab-item
          v-for="(item, index) in items"
          :key="index"
        >
          <component
            style="height:100%"
            :loading="loading"
            v-bind:is="item.component"
            v-bind="item.properties"
            :product="product"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { mapStateTwoWay } from '@/store'
  import axios from 'axios'

  import LocationSales from '@/components/Common/Product/LocationSales'
  import ProductSalesTransaction from '@/components/Common/Rental/Products/Transaction'
  import ProductSummary from '@/components/Common/Product/Summary'
  import productMixin from '@/mixins/product'

  export default {
    props: {
      productService: Object,
      transactionService: Object,
      locationService: Object,
    },

    components: {
      LocationSales,
      ProductSummary,
      ProductSalesTransaction
    },

    mixins: [
      productMixin
    ],

    data () {
      return {
        loading: true,

        items: [
          {
            name: 'Overview',
            component: 'ProductSummary'
          },
          {
            name: 'Sales by Location',
            component: 'LocationSales'
          },
          {
            name: 'Transactions',
            component: 'ProductSalesTransaction',
            properties: {
              productService: this.productService,
              transactionService: this.transactionService,
              locationService: this.locationService,
            }
          }
        ],

        cancelFetchToken: null,

        product: {}
      }
    },

    computed: {
      ...mapStateTwoWay('tabs', ['activeTab'], {
        activeTab: 'SET_ACTIVE_TAB'
      })
    },

    created () {
      this.SET_ITEMS(this.items)
      const CancelToken = axios.CancelToken

      // fetch data
      this.productService.get(this.$route.params.id, {
        cancelToken: new CancelToken(c => {
          this.cancelFetchToken = c
        })
      })
        .then(({ data }) => {
          this.product = data.data
          this.$store.commit('UPDATE_TITLE', this.getProductNameWithSku(this.product))
        })
        .catch(() => {
          // catch error
        })
        .finally(() => {
          this.loading = false
          this.cancelFetchToken = null
        })
    },

    beforeDestroy () {
      this.SET_ITEMS(null)
      if (this.cancelFetchToken) {
        this.cancelFetchToken()
        this.cancelFetchToken = null
      }
    },

    methods: {
      ...mapMutations('tabs', ['SET_ITEMS']),

      updateTab (value) {
        this.activeTab = value
      }
    }
  }
</script>

<style lang="stylus">
  .v-tabs
    overflow hidden

    > .nav-tab-bar
      z-index 2
</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Products/Product.vue